import { render } from '@wordpress/element';
import SolarCalculator from './components/SolarCalculator';
// import './styles/main.css';

// Function to initialize the calculator
window.initSolarCalculator = function(elementId) {
  const container = document.getElementById(elementId);
  if (container) {
    render(<SolarCalculator />, container);
  }
};